// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  userId: __t.u64().name("user_id"),
  weekStart: __t.u64().name("week_start"),
  tileLayout: __t.string().name("tile_layout"),
  revealedTiles: __t.string().name("revealed_tiles"),
  freePicksUsedToday: __t.u32().name("free_picks_used_today"),
  paidPicksToday: __t.u32().name("paid_picks_today"),
  lastPickDate: __t.u64().name("last_pick_date"),
  streakDays: __t.u32().name("streak_days"),
  createdAt: __t.u64().name("created_at"),
  totalSpins: __t.u64().name("total_spins"),
});
